export const CAT_BOPIS_MODAL_CLOSE_BUTTON_ARIA_LABEL = 'cat.bopis.modal.close_button_aria_label';
export const TOGGLE_SWITCH_LABEL = 'bopis_bar.toggle_switch_label';
export const TOGGLE_ENABLED_TEXT = 'bopis_bar.toggle_enabled_text';
export const TOGGLE_DISABLED_TEXT = 'bopis_bar.toggle_disabled_text';
export const BAR_LABEL_TEXT = 'bopis_bar.bar_label_text';
export const BAR_LABEL_TEXT_CURBSIDE = 'bopis_bar.bar_label_text_curbside';
export const MAP_LINK_ARIA_LABEL = 'cat.bopis.map_link_aria_label';
export const BAR_LABEL_TEXT_IN_STORE_AND_CURBSIDE = 'bopis_bar.bar_label_text_in_store_and_curbside';
export const PICKUP_IN_STORE_UNAVAILABLE = 'bopis_facet.unavailable_pickup_in_store';
export const PICKUP_CURBSIDE_UNAVAILABLE = 'bopis_facet.unavailable_pickup_curbside';
export const MODAL_CHANGE_STORE_TEXT = 'bopis_bar.modal_change_store_text';
export const TOGGLE_SWITCH_LABEL_CURBSIDE = 'bopis_bar.toggle_switch_label_curbside';
export const TOGGLE_ENABLED_TEXT_CURBSIDE = 'bopis_bar.toggle_enabled_text_curbside';
export const TOGGLE_DISABLED_TEXT_CURBSIDE = 'bopis_bar.toggle_disabled_text_curbside';
